import type { MfaAppConfig } from "@dwelldrop/shared";
import { auditActionSource } from "../utils/auditActionSource";

export const ADMIN_TOKEN_KEY = "venuehub_admin_token" as const;

export const ADMIN_MFA_CONFIG: MfaAppConfig = {
  app: "admin",
  issuer: "DwellDrop Admin",
  tokenStorageKey: ADMIN_TOKEN_KEY,
  loginRateKey: (email) => `login:admin:${email}`,
  auditActionSource,
};
